<template>
  <div class="pageStyle">
    <div class="top-bg"></div>
    <div class="top-title">
      <div>
        <span>反查客户</span>
        <span>上传客户列表实时匹配</span>
      </div>
      <div>
        <img
          src="https://static.xchengtech.cn/5927dc560b8048dc87ede7a09c175670.png"
          alt=""
        />
      </div>
    </div>
    <div class="content">
      <div class="title">
        <div>
          <span>匹配记录</span><span>总数{{ dataList.length }}条</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "XcExhibitionSystemBatchSearch",

  data() {
    return {
      dataList: [
        {
          fileName: "2025.3.4匹配企业",
          createDateTime: "1741051122000",
        },
        {
          fileName: "2025.3.3匹配企业",
          createDateTime: "1740964722000",
        },
        {
          fileName: "2025.3.2匹配企业",
          createDateTime: "1740878322000",
        },
      ],
    };
  },

  mounted() {},

  methods: {},
};
</script>
<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/view/customerCenter/module/batchSearch/index.vue